import { useEnsName } from 'wagmi'
import { isAddress } from 'viem'

/**
 * Hook to resolve ENS name from address (reverse resolution)
 * Only works on Ethereum mainnet
 */
export function useENSName(address?: string) {
  const {
    data: ensName,
    isLoading,
    isError,
    error
  } = useEnsName({
    address: address && isAddress(address) ? address as `0x${string}` : undefined,
    chainId: 1, // ENS is only on Ethereum mainnet
    query: {
      enabled: !!address && isAddress(address),
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
      retry: 1,
    }
  })

  return {
    ensName,
    isLoading,
    isError,
    error,
    hasENS: !!ensName
  }
}